import blogGroup from "./blog/blog-group.js"

setTimeout(function (e) {
    blogGroup()
}, 2000)
